import styled from "styled-components";
import { Link } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import { AWS_PROFILE_IMAGES_URL } from "constants";
import ToggleSwitch from "components/forms/ToggleSwitch";

import bronzeCheckmarkIcon from "assets/img/icons/checkmark-bronze.svg";
import silverCheckmarkIcon from "assets/img/icons/checkmark-silver.svg";
import goldCheckmarkIcon from "assets/img/icons/checkmark-gold.svg";
import imagePlaceholderIcon from "assets/img/icons/icons8-placeholder.svg";

const AdPlanPostSettings = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Setting = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SettingTitle = styled.div`
  margin-bottom: 5px;

  font-weight: 500;
`;

const SwitchLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SwitchLabel = styled.div`
  line-height: 1;
`;

const ProfileLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const AvatarIconWrap = styled.div`
  width: 40px;
  min-width: 40px;
  aspect-ratio: 1;
`;

const AvatarIcon = styled.img`
  width: 100%;
  border-radius: 50%;
`;

const UsernameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Username = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

const CheckmarkIcon = styled.div`
  padding-top: 2px;

  width: 18px;
  min-width: 18px;
  height: 18px;
`;

const PostSketchWrap = styled.div``;

const PostSketch = styled.div`
  width: 80px;
  height: 100px;

  border-radius: 8px;
  background: ${(props) =>
    props.highlighted ? "#496681" : css.FLAT_BOX_BACKGROUND};
  box-shadow: ${(props) =>
    props.highlighted ? "0px 0px 6px 1px rgba(255, 255, 255, 0.60)" : "none"};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const PostSketchIcon = styled.div`
  width: 48px;
  min-width: 48px;
  height: 48px;
`;

const Warning = styled.div`
  margin-top: 7px;

  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

export default ({
  data,
  profileData,
  onAdPlanSettingsToggleClick,
  loadingAdPlanSettingsToggle,
  postSettingsErrorMessage,
}) => {
  const { show_checkmark, highlighted_posts } = data.userProfileData;

  const { profileImage, username, adPlan } = profileData;

  let planIcon = goldCheckmarkIcon;

  switch (adPlan) {
    case 1:
      planIcon = bronzeCheckmarkIcon;
      break;
    case 2:
      planIcon = silverCheckmarkIcon;
      break;
  }

  return (
    <AdPlanPostSettings>
      <Setting>
        <SettingTitle>Checkmark</SettingTitle>
        <SwitchLine>
          <ToggleSwitch
            on={show_checkmark}
            onClick={() => onAdPlanSettingsToggleClick("checkmark")}
            loading={loadingAdPlanSettingsToggle}
          />
          <SwitchLabel>Show checkmark</SwitchLabel>
        </SwitchLine>
        <ProfileLine>
          <AvatarIconWrap>
            <AvatarIcon src={AWS_PROFILE_IMAGES_URL + profileImage} />
          </AvatarIconWrap>
          <UsernameBox>
            <Username>{username}</Username>
            {show_checkmark && (
              <CheckmarkIcon>
                <img src={planIcon} style={{ width: "100%" }} />
              </CheckmarkIcon>
            )}
          </UsernameBox>
        </ProfileLine>
      </Setting>
      <Setting>
        <SettingTitle>Highlighted Posts</SettingTitle>
        <SwitchLine>
          <ToggleSwitch
            on={highlighted_posts}
            onClick={() => onAdPlanSettingsToggleClick("highlightedPosts")}
            loading={loadingAdPlanSettingsToggle}
          />
          <SwitchLabel>Highlight posts</SwitchLabel>
        </SwitchLine>
        <PostSketchWrap>
          <PostSketch highlighted={highlighted_posts}>
            <PostSketchIcon>
              <img src={imagePlaceholderIcon} style={{ width: "100%" }} />
            </PostSketchIcon>
          </PostSketch>
        </PostSketchWrap>
        {postSettingsErrorMessage && (
          <Warning>{postSettingsErrorMessage}</Warning>
        )}
      </Setting>
    </AdPlanPostSettings>
  );
};
